export default __webpack_public_path__ + "static/media/Inter-Light.c08cfeeb.woff";